/** Height reserved for the route-level Suspense fallback so navigation does not collapse the layout. */
export const ROUTE_FALLBACK_MIN_HEIGHT = "60vh";

/** Diameter of the spinner shown while a route chunk downloads. */
export const ROUTE_FALLBACK_SPINNER_SIZE = 32;
